import PropTypes from 'prop-types';
// @flow

import React, {Component} from 'react';

// -- constants
import ViewConstants from 'constants/ViewConstants';
import ViewUtils from 'PMT/utils/ViewUtils';

// -- views
import ColorPickerModal from './ColorPickerModal';

class ColorView extends Component {

  static defaultProps = {
    color: ViewConstants.ColorView.DEFAULT_COLOR,

    size: ViewConstants.ColorView.DEFAULT_SIZE,

    enablePicker: false,

    onColorChange: () => {
    }
  };

  static propTypes = {
    color: PropTypes.number,

    size: PropTypes.number,

    enablePicker: PropTypes.bool,

    /**
     * must be set if enablePicker is set tot true.
     * param: number (color)
     */
    onColorChange: PropTypes.func
  };

  state = {
    displayPicker: false
  };

  // -- events
  onOpenPicker = () => {
    if (this.props.enablePicker) {
      this.setState({
        displayPicker: true
      });
    }
  };

  onClosePicker = () => {
    this.setState({
      displayPicker: false
    });
  };

  onColorChange = (color: string) => {
    this.onClosePicker();
    this.props.onColorChange(color);
  };

  // -- renderers

  render() {
    const style = {
      backgroundColor: ViewUtils.uintColorToRgbaFormat(this.props.color),
      width: `${this.props.size}px`,
      height: `${this.props.size}px`
    };

    let mainClass = 'color_view';

    if (this.props.enablePicker) {
      mainClass += ' pointer';
    }

    // get the type of color (light or dark) to put the inverse border
    if (ViewUtils.isVeryLightColor(this.props.color)) {
      mainClass += ' color_view_light';
    } else {
      mainClass += ' color_view_dark';
    }

    return (
        <>
          <div
              className={mainClass}
              style={style}
              onClick={this.onOpenPicker}
          >
          </div>
          {this.props.enablePicker &&
              <ColorPickerModal
                  show={this.state.displayPicker}
                  onHide={this.onClosePicker}
                  color={this.props.color}
                  onChange={this.onColorChange}
              />
          }
        </>
    );
  }

}

export default ColorView;
